import { render, staticRenderFns } from "./TextVerticalIcon.vue?vue&type=template&id=fa0a5bee&"
import script from "./TextVerticalIcon.vue?vue&type=script&lang=ts&"
export * from "./TextVerticalIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports